import React, { Component } from 'react'
import { Row, Col, Icon } from 'antd';

const antIcon = <Icon type="file-add" style={
  {
    fontSize: 150,
    height: "150px",
    width: "150px",
  }} />;

class Web3NoContract extends Component {
  render() {
    return (
      <div className="loading-screen">
        <Row type="flex" justify="center" align="middle">
          <Col className="barrier-col" span={6}></Col>
          <Col className="" span={12}>
            <Row type="flex" justify="center" align="middle">
              <Col span={2}></Col>
              <Col className="barrier-content" span={20}>

                <h1>Mevu is not currently on this network</h1>
                {antIcon}
                <br /><br />
                <p>Please switch to the Rinkeby test network</p>               
                <img src="https://i.imgur.com/P2eH3gl.png"/>
                

              </Col>
              <Col span={2}></Col>
            </Row>
          </Col>
          <Col className="barrier-col" span={6}></Col>
        </Row>
      </div>
    )
  }
}

export default Web3NoContract;



// WEBPACK FOOTER //
// ./src/components/web3Components/web3NoContract.js